import { resolveInitialTheme } from '@/utils/theme'

export const state = {
  user: null,
  error: null,
  loading: false,
  loadingDescript: '',
  // KAN-95 暗室暗色主題：'light' | 'dark'
  // 開機即以 resolveInitialTheme() 解析（localStorage 持久值優先，否則系統偏好），
  // 讓第一次 render 就是正確主題（配合 main.js mount 前套 root class 防閃）
  ui: {
    theme: resolveInitialTheme(),
  },
  setting: {
    asr_domain: '',
    asr_ws_port: '',
    asr_ws_path: '',
    asr_ws_realtime_port: '',
    asr_ws_realtime_path: '',
    tts_port: '',
    tts_path: '',
    demo: false,
    screenshot: false,
    descriptive: false,
  },
  // 醫院別 runtime 配置（由 /api/config/runtime 載入，見 main.js）
  // null 代表尚未載入；載入後為 frozen object
  hospital: null,
}
